import type { UntitledIconData } from '../../UntitledIconData'

const ulRefreshCw02: UntitledIconData = {
  prefix: 'ul',
  name: 'refresh-cw-02',
  paths: [
    {
      shape:
        'M2 14C2 14 2.12132 14.8492 5.63604 18.364C9.15076 21.8787 14.8492 21.8787 18.364 18.364C19.6092 17.1187 20.4133 15.5993 20.7762 14M2 14V20M2 14H8M22 10C22 10 21.8787 9.15076 18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604C4.39076 6.88131 3.58669 8.40072 3.22383 10M22 10V4M22 10H16',
    },
  ],
}

export default ulRefreshCw02
